import { Component, Input } from '@angular/core';
import { CodaltComponent } from '../codalt.component';
import { Customer } from '../customer';
import { ConfirmDialogService } from '../services/confirm-dialog-service/confirm-dialog.service';
import { CustomerService } from '../services/customer/customer.service';

@Component({
    selector: 'app-customer-logo',
    templateUrl: './customer-logo.component.html',
    styleUrls: ['./customer-logo.component.scss'],
    standalone: false,
})
export class CustomerLogoComponent extends CodaltComponent {
    @Input()
    customer: Customer;

    constructor(
        private customerService: CustomerService,
        private confirmDialogService: ConfirmDialogService
    ) {
        super();
    }

    uploadLogo(event) {
        event.stopPropagation();
        event.preventDefault();
        const file = event.srcElement.files[0];
        if (file.type === 'image/svg+xml') {
            const reader = new FileReader();
            reader.readAsText(file, 'UTF-8');
            reader.onload = evt => {
                this.customer.icon = `data:image/svg+xml;base64,${window.btoa(evt.target.result + '')}`;
                this.customerService.saveCustomerIcon(this.customer.icon).subscribe();
            };
        } else if (['image/jpeg', 'image/png'].indexOf(file.type) !== -1) {
            const img = new Image();
            img.src = window.URL.createObjectURL(file);
            img.onload = () => {
                const factor = 200 / Math.max(img.naturalWidth, img.naturalHeight);
                const width = factor < 1 ? img.naturalWidth * factor : img.naturalWidth;
                const height = factor < 1 ? img.naturalHeight * factor : img.naturalHeight;
                const elem = document.createElement('canvas');
                elem.width = width;
                elem.height = height;
                const ctx = elem.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);
                if (file.type === 'image/png') {
                    this.customer.icon = ctx.canvas.toDataURL('image/png');
                } else {
                    this.customer.icon = ctx.canvas.toDataURL('image/jpeg', 0.7);
                }
                this.customerService.saveCustomerIcon(this.customer.icon).subscribe();
            };
        } else {
            this.confirmDialogService
                .confirm('Verkeerd bestand', 'Dit bestandsformaat wordt niet ondersteund', 'Oké')
                .then(() => {})
                .catch(() => {});
        }
    }
}
